export default "__VITE_ASSET__DDKVhjW4__"